module.exports = __webpack_public_path__ + "img/icon-plus.72f3ee5a.svg";